import { RefreshCw } from 'lucide-react';
import { useI18n } from '../../i18n/index.js';

type Props = {
  /** תווית מוכנה לצד הסמן. ברירת המחדל מתורגמת — ראו למטה. */
  label?: string;
  /** Visual size — 'inline' for inside a card row, 'block' to fill a card */
  variant?: 'inline' | 'block';
};

// Phase 1C UI polish: replaces 3+ ad-hoc loading patterns across the
// dashboard (text-only 'טוען…', RefreshCw + text, plain divs) with one
// consistent indicator. Pair with <DataError> — together they cover the
// 'something async is happening' surface area.
//
// Conventions:
//   <Loading />                  — default inline indicator
//   <Loading variant="block" />  — centered, padded for full-card use
//   <Loading label={t('…')} />   — task-specific label
//
// ── ⚠ ומה שתוקן כאן 20/09/2026 ──────────────────────────────────────────
//
// ברירת המחדל הייתה `label = 'טוען...'` **קשיחה**, ו-`dir="rtl"` קבוע.
// הרכיב הזה יושב ב-14 קבצים, וחלקם מסכים שתורגמו לרוסית — כלומר מסך
// רוסי עבר לעברית בדיוק ברגע שמשהו נטען. ראו edal-i18n-child-components.
export function Loading({ label, variant = 'inline' }: Props): JSX.Element {
  const { t, dir } = useI18n();
  const text = label ?? t('ui.loading');
  if (variant === 'block') {
    return (
      <div
        className="flex flex-col items-center justify-center gap-2 py-10 text-slate-400"
        dir={dir}
        role="status"
        aria-live="polite"
      >
        <RefreshCw className="w-5 h-5 animate-spin" />
        <span className="text-sm">{text}</span>
      </div>
    );
  }
  return (
    <div
      className="flex items-center gap-2 text-sm text-slate-400"
      dir={dir}
      role="status"
      aria-live="polite"
    >
      <RefreshCw className="w-4 h-4 animate-spin" />
      <span>{text}</span>
    </div>
  );
}
